import { DataLayer } from './data-layer';

const dataLayer = new DataLayer();

export const onDataLayer = (success, code, details, description) => {
    dataLayer.pushOnDataLayer({
        'event': 'submit_status',
        'submit_details': {
            'form_name': 'formulario-de-inscricao', // Nome do formulário
            'form_campaign': 'expedicao-enem-verso', // Nome da campanha, caso haja 
            'id': null, // Id de identificação do usuário criado, caso haja
            'success': dataLayer.sanitizeText(success), // Status de sucesso
            'code': code, // Código do erro, caso haja
            'description': `${dataLayer.sanitizeText(details)}:${dataLayer.sanitizeText(description)}` // Descrição do erro, caso haja
        }
    })
};